/**
 * Shared file upload validation constants and helpers
 */

// Allowed file extensions for upload
// Note: PPT/PPTX not supported - Pandoc cannot process PowerPoint files
export const ALLOWED_EXTENSIONS = ['.doc', '.docx', '.pdf', '.md', '.yaml', '.yml', '.json'];
export const ALLOWED_EXTENSIONS_DISPLAY = 'DOC, DOCX, PDF, MD, YAML, JSON';

// Maximum file size for upload (40 MB)
export const MAX_FILE_SIZE_MB = 40;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

/**
 * Check if a filename has an allowed extension
 */
export function isFileTypeAllowed(filename: string): boolean {
  const lowerName = filename.toLowerCase();
  return ALLOWED_EXTENSIONS.some(ext => lowerName.endsWith(ext));
}

// Re-export formatFileSize from existing utility
export { formatFileSize } from './formatFileSize';
